import proyecto from "../../api/Proyecto";

// Catálogo
export const getServiciosDigitalesCatalogo = async ({ q = "", activos = "1" } = {}) => {
  const response = await proyecto.get("/servicios-digitales/catalogo", { params: { q, activos } });
  return response.data;
};

export const crearServicioDigitalCatalogo = async (payload) => {
  const response = await proyecto.post("/servicios-digitales/catalogo", payload);
  return response.data;
};

export const actualizarServicioDigitalCatalogo = async (id, payload) => {
  const response = await proyecto.put(`/servicios-digitales/catalogo/${id}`, payload);
  return response.data;
};

export const desactivarServicioDigitalCatalogo = async (id) => {
  const response = await proyecto.delete(`/servicios-digitales/catalogo/${id}`);
  return response.data;
};

// Asignaciones
export const getServiciosDigitalesAsignaciones = async (params = {}) => {
  const response = await proyecto.get("/servicios-digitales/asignaciones", { params });
  return response.data;
};

export const crearServicioDigitalAsignacion = async (payload) => {
  const response = await proyecto.post("/servicios-digitales/asignaciones", payload);
  return response.data;
};

export const actualizarServicioDigitalAsignacion = async (id, payload) => {
  const response = await proyecto.put(`/servicios-digitales/asignaciones/${id}`, payload);
  return response.data;
};

export const desactivarServicioDigitalAsignacion = async (id) => {
  const response = await proyecto.delete(`/servicios-digitales/asignaciones/${id}`);
  return response.data;
};

export const getServicioDigitalCredenciales = async (id) => {
  const response = await proyecto.get(`/servicios-digitales/asignaciones/${id}/credenciales`);
  return response.data;
};

// Cobros
export const getServiciosDigitalesCobros = async (params = {}) => {
  const response = await proyecto.get("/servicios-digitales/cobros", { params });
  return response.data;
};

export const crearServicioDigitalCobro = async (payload) => {
  const response = await proyecto.post("/servicios-digitales/cobros", payload);
  return response.data;
};
